import { atom, useSetAtom } from 'jotai';

export interface UpdateFolderTitlePayload {
  id: string;
  title: string;
  onSave: (newTitle: string) => void;
}

export const updateFolderTitlePayloadAtom = atom<
  UpdateFolderTitlePayload | undefined
>(undefined);

export const useOpenUpdateFolderTitleModal = () =>
  useSetAtom(updateFolderTitlePayloadAtom);
